import Availability from '../Availability'

export default class SaveAvailabilityMutationPayload {
  availability: Availability

  constructor (availability: Availability) {
    this.availability = availability
  }
}
